import React, { useState, useEffect } from 'react';
import { Dropdown, Button, Menu, Typography } from 'antd';
import './DropdownOwnerships.scss';
import { useOwnership } from '../../../../../features/onboarding/context/OwnershipContext';
import { Ownership } from '../../../../../types';

const { Text } = Typography;

interface DropdownOwnershipsProps {
  items?: Ownership[];
  onSelect?: () => void;
  onAddNew?: () => void;
  disabled?: boolean;
  guarantorFirstName?: string;
  guarantorLastName?: string;
  newItemLabel?: string;
}

const DropdownOwnerships = ({
  items = [],
  onSelect = () => {},
  onAddNew = () => {},
  disabled = false,
  guarantorFirstName,
  guarantorLastName,
  newItemLabel = 'NEW GUARANTOR',
}: DropdownOwnershipsProps) => {
  const { ownershipSelected, setOwnershipSelected } = useOwnership();
  const [selectedLabel, setSelectedLabel] = useState('');

  useEffect(() => {
    if (!ownershipSelected && items.length > 0) {
      setOwnershipSelected(items[0]);
    }
  }, [items, ownershipSelected, setOwnershipSelected]);

  useEffect(() => {
    if (!ownershipSelected) {
      setSelectedLabel('');
      return;
    }

    if (ownershipSelected.isNew) {
      // Si hay nombre de guarantor ingresado, mostrarlo en lugar de "Someone else"
      const firstName = guarantorFirstName || '';
      const lastName = guarantorLastName || '';
      const fullName = `${firstName} ${lastName}`.trim();
      setSelectedLabel(fullName || 'Someone else');
      return;
    }

    setSelectedLabel(`${ownershipSelected.name} ${ownershipSelected.lastname}`);
  }, [ownershipSelected, guarantorFirstName, guarantorLastName]);

  const handleClick = ({ key }: { key: string }) => {
    if (key === '__new__') {
      const firstName = guarantorFirstName || '';
      const lastName = guarantorLastName || '';
      const fullName = `${firstName} ${lastName}`.trim();
      setSelectedLabel(fullName || 'Someone else');
      setOwnershipSelected({ _id: '', email: '', state: '', name: 'Someone', lastname: 'else', isNew: true} as Ownership)
      onAddNew();
    } else {
      const selectedItem = items.find(item => item._id === key);
      if (selectedItem) {
        setOwnershipSelected(selectedItem);
        onSelect();
      }
    }
  };

  const menuItems = items.map((item, index) => (
    <Menu.Item 
      key={item._id} 
      className={''}
    >
      <div className="item-row">
        <span>{`${item.name} ${item.lastname}`}</span>
        {item.loans !== undefined && (
          <Text type="secondary" style={{marginLeft: '95px', fontSize: '12px'}}>{item.loans.length} loans</Text>
        )}
      </div>
    </Menu.Item>
  ));

  menuItems.push(
    <Menu.Item key="__new__" className="guarantor-dropdown-add">
      <div className='item-row-new'>+ {newItemLabel}</div>
    </Menu.Item>
  );

  const menu = <Menu onClick={handleClick}>{menuItems}</Menu>;

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      disabled={disabled}
      overlayClassName="guarantor-dropdown"
    >
      <Button
        type={disabled ? 'text' : 'link'}
        className={`guarantor-button${disabled ? ' disabled' : ''}`}
        disabled={disabled}
      >
        {selectedLabel || 'Select...'}
      </Button>
    </Dropdown>
  );
};

export default DropdownOwnerships;
